import { useEffect } from 'react';
import ExoPositions from '../exo/ExoPositions';

const StepPositions = ({
  updateDataCollection,
  dataCollection,
  updateValidation,
  imageType,
  imageApiFilter,
  collapseModules,
  hideHOAI,
  hideTimeBilling,
}) => {
  function handlePositionChange(positions, hoaiData) {
    // Use functional update to avoid stale closure issues
    updateDataCollection((prev) => ({
      ...prev,
      positions: positions,
      ...(hoaiData ? { hoaiData: hoaiData } : {}),
    }));
  }

  function handleTimeTrackingDataChange(timeTrackingData) {
    // Use functional update to avoid stale closure issues
    updateDataCollection((prev) => ({
      ...prev,
      timeTrackingData: timeTrackingData,
    }));
  }

  // validation
  useEffect(() => {
    var pos = dataCollection.positions;
    if (pos == undefined) pos = [];
    var valPositions = true;

    for (let index = 0; index < pos.length; index++) {
      if (
        !pos[index].isGroup &&
        (!pos[index].name ||
          isNaN(pos[index].price) ||
          isNaN(pos[index].amount))
      ) {
        valPositions = false;
      }
    }
    updateValidation(valPositions);
  }, [dataCollection]);

  return (
    <ExoPositions
      imageType={imageType}
      imageApiFilter={imageApiFilter}
      onPositionChange={handlePositionChange}
      onTimeTrackingDataChange={handleTimeTrackingDataChange}
      timeTrackingData={dataCollection.timeTrackingData}
      startPositions={dataCollection.positions}
      collapseModules={collapseModules}
      defaultTaxRate={
        dataCollection.templateMetaData &&
        dataCollection.templateMetaData.taxRate
      }
      hoaiData={dataCollection.hoaiData}
      hideHOAI={hideHOAI}
      title={dataCollection.title}
      hideTimeBilling={hideTimeBilling}
      skonto={
        Boolean(Number(dataCollection?.discount))
          ? dataCollection?.discountRate
          : null
      }
      project={dataCollection.project}
    />
  );
};

export default StepPositions;
